module.exports = __webpack_public_path__ + "img/fashion_13.eb746019.jpg";